import React from "react";
import User from "../../assets/data/user.js";

function NewAdd() {
  const TotalUser = User.length;
  return (
    <div className="MainDashboard flex items-center justify-between">
      <div className="Table lg:w-[420px] md:w-[420px] w-[360px] rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">New Users</h2>
          <div className="relative">
            <i
              className="fa fa-bell text-[24px] relative"
              aria-hidden="true"
            ></i>
            {TotalUser > 0 && (
              <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {TotalUser}
              </span>
            )}
          </div>
        </div>

        {/* Table Container with Scroll */}
        <div className="overflow-y-auto" style={{ height: "250px" }}>
          <table className="w-full border-collapse text-sm">
            {/* Sticky Table Header */}
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Name</th>
                <th className="p-2 border-b">Phone</th>
                <th className="p-2 border-b">Address</th>
                <th className="p-2 border-b">Profile</th>
              </tr>
            </thead>
            <tbody>
              {User.map((user) => (
                <tr className="hover:bg-gray-100" key={user._id}>
                  <td className="p-2 border-b text-center">{user.Name}</td>
                  <td className="p-2 border-b text-center">{user.phone}</td>
                  <td className="p-2 border-b text-center">{user.address}</td>
                  <td className="p-2 border-b text-center">
                    <img
                      src={user.image}
                      alt="ProfilePhoto"
                      className="w-8 h-8 rounded-full"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default NewAdd;
